<template>
  <div class="floating-winfow-wrapper" @click="handleClick">
    <div style="display:flex;align-items:center;justify-content:center;position:relative;">
        <div style="width:48px;height:48px;">
          <img src="@/assets/image/android-floating-icon.png" style="width:100%;height:100%;display:inline-block;" alt="">
        </div>
        <!-- <div class="traning">运输中</div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'DriverFloatingAndroidWindow',

  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    handleClick(){
        Android.onClickFW("")
    }
  },
};
</script>
<style>
body {
        background-color: transparent;
    }
</style>

<style lang="scss" scoped>
    .floating-winfow-wrapper {
        position: fixed;
        top: 0;
        left: 0;
        background-color: transparent;
        // width: 184px;
        // height: 184px;
        width: 100%;
        height: 100%;
        border-radius:12px;
        overflow: hidden;
        .traning {
            background: linear-gradient( 180deg, #FFD64C 0%, #FFB246 29%, #FF8B5E 100%);
            border-radius: 20px;
            color: #ffffff;
            padding: 3px 10px;
            position: absolute;
            bottom: -16px;
            z-index: 2;
        }
    }
</style>